import React, { useEffect, useState } from 'react';
import { message, Button } from 'antd';
import {
  EnvironmentOutlined,
  CalendarOutlined,
  PhoneOutlined,
  UserOutlined
} from '@ant-design/icons';

const AssignedEventPhotographer = ({ onEventClick }) => {
  const [assignedEvents, setAssignedEvents] = useState([]);

  // ✅ Move this out of useEffect
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!user || user.role !== 'photographer') {
      message.error("Unauthorized access");
      return;
    }

    fetch('http://localhost:5000/assigned-events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ photographerId: user._id })
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setAssignedEvents(data);
        } else {
          message.warning("No assigned events found.");
        }
      })
      .catch(err => {
        message.error("Failed to fetch assigned events.");
        console.error(err);
      });
  }, []);

  return (
    <div className="container">
      <h2 className="mb-4">Assigned Events</h2>
      {assignedEvents.length === 0 ? (
        <p>No assigned events.</p>
      ) : (
        <div className="d-flex flex-column gap-4">
          {assignedEvents.map((event, idx) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                border: '1px solid #ccc',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                marginBottom: '20px'
              }}
            >
              {/* Cover Image */}
              {event.event_photo && (
                <img
                  src={`http://localhost:5000/uploads/${event.event_photo}`}
                  alt="Event"
                  style={{
                    width: '250px',
                    height: '200px',
                    objectFit: 'cover',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                />
              )}

              {/* Details Section */}
              <div style={{ padding: '16px', flex: 1 }}>
                <h3 style={{ marginBottom: 10 }}>{event.event_name}</h3>

                {event.client_name && (
                  <p style={{ margin: '6px 0' }}>
                    <UserOutlined /> <strong>Client:</strong> {event.client_name}
                  </p>
                )}

                {event.client_contact && (
                  <p style={{ margin: '6px 0' }}>
                    <PhoneOutlined /> <strong>Contact:</strong> {event.client_contact}
                  </p>
                )}

                {event.location && (
                  <p style={{ margin: '6px 0' }}>
                    <EnvironmentOutlined /> <strong>Location:</strong> {event.location}{" "}
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        event.location
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button type="link" size="small">Map</Button>
                    </a>
                  </p>
                )}

                {(event.start_date || event.end_date) && (
                  <p style={{ margin: '6px 0' }}>
                    <CalendarOutlined /> <strong>Date:</strong>{" "}
                    {event.start_date ? new Date(event.start_date).toLocaleDateString() : "N/A"} →{" "}
                    {event.end_date ? new Date(event.end_date).toLocaleDateString() : "N/A"}
                  </p>
                )}

                <Button
                  type="primary"
                  onClick={() => {
  // Log the view action
  fetch('http://localhost:5000/api/user_logs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: user.name,
      role: 'photographer',
      action: 'Clicked View Event',
      event_name: event._id,
      details: `Event Name: ${event.event_name}`
    })
  }).catch(console.error);

  onEventClick(event._id, event.event_name, event.pin);
}}

                >
                  View Event
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AssignedEventPhotographer;
